module.exports = __webpack_public_path__ + "media/svg/logo-topo-fixo-efc64965.svg";